module.exports = __webpack_public_path__ + "img/luza1.557d68d9.png";